export { default as AddressCard } from './AddressCard';
export { default as ClipboardMedical } from './ClipboardMedical';
export { default as FileCircleQuestion } from './FileCircleQuestion';
export { default as HeadSideMedical } from './HeadSideMedical';
export { default as HexagonExclamation } from './HexagonExclamation';
export { default as LaptopMedical } from './LaptopMedical';
export { default as NotesMedical } from './NotesMedical';
export { default as Prescription } from './Prescription';
export { default as ScrewdriverWrench } from './ScrewdriverWrench';
export { default as UserDoctor } from './UserDoctor';

export const iterableIconTypes = [
  'AddressCard',
  'ClipboardMedical',
  'FileCircleQuestion',
  'HeadSideMedical',
  'HexagonExclamation',
  'LaptopMedical',
  'NotesMedical',
  'Prescription',
  'ScrewdriverWrench',
  'UserDoctor',
] as const;

export type IconTypes = typeof iterableIconTypes[number];
